module.exports = __webpack_public_path__ + "static/media/person_yihsuan.3ba89328.png";